<template>
  <div class="header" v-if="headerVisible">
    <img src="./assets/cupshe.png" alt="" />
  </div>
  <!-- <keep-alive> -->
  <router-view />
  <!-- </keep-alive> -->
  <div class="footer" v-if="footerVisible">
    <div class="share">
      <a class="share-item" :href="`mailto:${$t('mailto')}@cupshe.com`">
        <img src="./assets/icon_mail.png" alt="" />
        <span class="share-text c-muli-semibold">{{ $t("email") }}</span>
      </a>
      <a class="share-item" :href="$t('contactUrl')" target="_blank">
        <img src="./assets/icon_msg.png" alt="" />
        <span class="share-text c-muli-semibold">{{ $t("contact us") }}</span>
      </a>
      <a
        v-if="$t('siteId') === '4'"
        class="share-item"
        href="https://es.cupshe.com/pages/preguntas-frecuentes"
        target="_blank"
      >
        <img src="./assets/icon_faq.png" alt="" />
        <span class="share-text c-muli-semibold">FAQ</span>
      </a>
      <a
        v-if="!['2', '3', '4'].includes($t('siteId'))"
        class="share-item"
        :href="`https://${$t(
          'siteName'
        )}.cupshe.com/pages/contact-us?live_chat=1`"
        target="_blank"
      >
        <img src="./assets/icon_chat.png" alt="" />
        <span class="share-text c-muli-semibold">{{ $t("chat") }}</span>
      </a>
    </div>
    <div
      class="info c-muli-light"
      v-html="$t('mailText', { mailto: $t('mailto'), domain: '@cupshe.com' })"
    ></div>
    <div class="copyright c-muli-light">
      {{ $t("copyright", { year: new Date().getFullYear(), sitename: $t("site").toUpperCase() }) }}
    </div>
  </div>
  <c-popup v-model:show="state.reward" closeable>
    <div style="text-align: center" class="reward_pop">
      <img src="./assets/review_reward.png" alt="" width="60" height="60" />
      <div class="c-muli-semibold" style="margin-top: 24px">
        {{ $t("RewardsToast") }}
      </div>
    </div>
  </c-popup>
</template>

<script setup>
import { onMounted, ref, provide, reactive } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
let headerVisible = ref(false);
let footerVisible = ref(false);
const state = reactive({ reward: false });
provide("app", state);
onMounted(() => {
  let href = window.location.href;
  if (
    href.indexOf("reSubscribe") >= 0 ||
    href.indexOf("newResubscribe") >= 0 ||
    href.indexOf("newReSubscribe") >= 0
  ) {
    headerVisible.value = false;
    footerVisible.value = false;
  } else {
    headerVisible.value = true;
    footerVisible.value = true;
  }
  document.title = t("pageTitle");
});
</script>

<style lang="less" scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

.reward_pop {
  padding: 40px;
  width: 440px;
  box-sizing: border-box;
  font-size: 14px;

  @media (max-width: 768px) {
    width: 312px;
    padding: 24px;
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .header {
    height: 80px;
    border-bottom: 1px solid #f7f7f7;
    text-align: center;

    img {
      width: 130px;
      height: 36px;
      margin-top: 22px;
    }
  }

  .footer {
    padding: 0 16px 20px;
    text-align: center;

    .share {
      display: flex;
      justify-content: center;
      height: 64px;
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 16px;

      .share-item {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
        }

        &:not(:last-child) {
          margin-right: 36px;
        }

        .share-text {
          font-size: 12px;
          color: #333;
          line-height: 15px;
          text-transform: uppercase;
          margin-left: 6px;
        }
      }
    }

    .info {
      font-size: 12px;
      color: #333;
      line-height: 18px;

      a {
        color: #333;
        text-decoration: underline;
      }
    }
    .copyright {
      font-size: 12px;
      color: #999;
      line-height: 15px;
      margin-top: 16px;
    }
  }
}

@media (min-width: 769px) {
  .header {
    height: 104px;
    border-bottom: 1px solid #f7f7f7;
    text-align: center;

    img {
      width: 160px;
      height: 43px;
      margin-top: 30px;
    }
  }

  .footer {
    padding: 32px 0;
    text-align: center;
    border-top: 1px solid #f7f7f7;

    .share {
      display: flex;
      justify-content: center;

      .share-item {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 24px;
          height: 24px;
        }

        &:not(:last-child) {
          margin-right: 60px;
        }
        .share-text {
          font-size: 12px;
          color: #333;
          line-height: 15px;
          text-transform: uppercase;
          margin-left: 8px;
        }
      }
    }

    .info {
      margin-top: 18px;
      font-size: 14px;
      color: #333;
      line-height: 18px;

      a {
        color: #333;
        text-decoration: underline;
      }
    }
    .copyright {
      font-size: 14px;
      color: #999;
      line-height: 18px;
      margin-top: 12px;
    }
  }
}
</style>
